export default {
  handler: 'relativeUrl',
  data: ({ sportId, meetingId }) => `/sports/${sportId}/meetings/${meetingId}/all`,
};
